module.exports = __webpack_public_path__ + "static/media/beliefs@2x.caded9ad.png";